import React from 'react';
import s from './InfoPanel.module.scss';

export const InfoPanel = ({ title }) => (
  <div className={s.InfoPanel}>{title}</div>
);
